import { render, staticRenderFns } from "./SettingsGdpr.vue?vue&type=template&id=2005871e&scoped=true"
import script from "./SettingsGdpr.vue?vue&type=script&lang=js"
export * from "./SettingsGdpr.vue?vue&type=script&lang=js"
import style0 from "./SettingsGdpr.vue?vue&type=style&index=0&id=2005871e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2005871e",
  null
  
)

export default component.exports